import type { FacadeSpec, HouseOpenings, Opening } from './openings';
import type { Lot } from './types';

/** Fitted completion of the merchant plots: docs/damrak-blocks.md, water access. */
export const DAMRAK_WATER_RECESS = 0.22;

export function isDamrakWaterfront(lot: Lot): boolean {
  return lot.reconstruction?.waterfront === 'damrak';
}

/** Keep the street/court elevation, but give the exposed water gable loading access. */
export function damrakWaterOpenings(spec: FacadeSpec, openings: HouseOpenings): HouseOpenings {
  const eaves = spec.storeys * spec.storeyHeight;
  const doorWidth = Math.min(2.25, spec.width * 0.43);
  const doorHeight = Math.min(2.45, spec.storeyHeight - 0.5);
  const back: Opening[] = [
    {
      kind: 'loftDoor',
      x: (spec.width - doorWidth) / 2,
      y: 0.18,
      width: doorWidth,
      height: doorHeight,
    },
  ];
  // One small working light per upper floor, rather than a second residential facade.
  for (let floor = 1; floor < spec.storeys; floor++) {
    back.push({
      kind: 'smallWindow',
      x: spec.width * 0.24 - 0.3,
      y: floor * spec.storeyHeight + 0.85,
      width: 0.6,
      height: 1,
    });
  }
  const rise = (spec.width / 2) * Math.tan(spec.pitch);
  const sill = 0.32;
  const height = Math.min(1.75, rise - 0.85);
  const width = Math.min(1.35, spec.width - (2 * (sill + height + 0.3)) / Math.tan(spec.pitch));
  const backGable: Opening[] =
    width > 0.6 && height > 0.8
      ? [
          {
            kind: 'loftDoor',
            x: (spec.width - width) / 2,
            y: eaves + sill,
            width,
            height,
          },
        ]
      : [];
  return { ...openings, back, backGable };
}
